module.exports = __webpack_public_path__ + "images/logo.png?67161eedd2ae61ee032f4b56946b0e28";